<template>
  
  <div class="chartConexao">
      <div class="chartItemTitulo">Status da Conexão </div>
    <div class="chartItemIcone" id="iconeConexaochart">
      <i class="fas fa-broadcast-tower"></i>
    </div>
    <div class="chartItemValor" id="valorConexaochart">DESCONECTADO </div>
    <div class="chartItemSubValor">Última conexão<br>07/02/2020 - 18:21h</div>
  </div>

</template>

<script>

export default {
    name: 'ChartConexao'
}
</script>

<style>
.chartConexao {
  position: relative;
  width:100%;
  min-width: 200px;
  height: 100%;
  min-height: 300px;
}
#valorConexaochart {
  color: rgb(145, 145, 145);
  text-shadow: 2px 2px #000;
  font-size: 2.5em;
  margin-top: 10px;
}
.chartItemSubValor {
  color: #ffd618;
  text-align: center;
}
#iconeConexaochart {
  color: red;
}
</style>